import Vue from 'vue';
import Router from 'vue-router';

import routes from '@/router/routes';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((match) => match.path.includes('client'))) {
    if (store.state.client.isLogged) {
      next();
    } else {
      next({
        path: '/login',
        replace: true,
        query: {
          redirect: to.path,
          token: to.query.token,
        },
      }, () => {}, () => {});
    }
  } else { next() }
});

export default router;
